var React = require('react');

function CurrencyInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeLinecap":"square","strokeWidth":"2","fill":"none","stroke":"currentColor","strokeMiterlimit":"10"},React.createElement("path",{"d":"M12 1v22M16.5 4A11.291 11.291 0 0012 3C9.47 3 6.5 4 6.5 7c0 6 11 3 11 9 0 3-2.516 3.977-5.5 4a18.041 18.041 0 01-6-1"})));
}

CurrencyInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CurrencyInline;

CurrencyInline.default = CurrencyInline;
